export const CircularProgress = ({ percentage, displayValue }) => {
    const getProgressArc = () => {
        const angle = (percentage / 100) * 360;
        
        if (percentage === 0) {
            return "";
        }
        
        const radians = ((angle - 90) * Math.PI) / 180;
        const x = 50 + 40 * Math.cos(radians);
        const y = 50 + 40 * Math.sin(radians);
        const largeArc = angle > 180 ? 1 : 0;

        if (percentage >= 99.9) {
            return "M 50 10 A 40 40 0 1 1 49.99 10";
        }

        return `M 50 10 A 40 40 0 ${largeArc} 1 ${x} ${y}`;
    };

    return (
        <div className="w-8 h-8 relative flex-shrink-0">
            <svg viewBox="0 0 100 100" className="transform -rotate-90 w-full h-full">
                {/* Background circle */}
                <circle 
                    cx="50" 
                    cy="50" 
                    r="40" 
                    fill="none" 
                    stroke="rgba(255, 255, 255, 0.3)" 
                    strokeWidth="8"
                />
                {/* Progress arc - border that fills up based on percentage */}
                <path
                    d={getProgressArc()}
                    fill="none"
                    stroke="rgba(255, 255, 255, 0.9)"
                    strokeWidth="8"
                    strokeLinecap="round"
                />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-xs font-bold text-white">
                    {displayValue}
                </span>
            </div>
        </div>
    );
};
